export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Final (2)_00.4dd0cd20.jpg";